<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">收银流水</h1>
                    <p class="text-white pb-3 px-3">เลือกจำนวนเครดิต หรือ ระบุจำนวนเครดิต เพื่อทำการเติมเข้ากระเป๋าของคุณ
                    </p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-3 m-1">
                                    <date-range-picker
                                        class="w-100"
                                        :opens="'center'"
                                        :min-date="minDate"
                                        :max-date="maxDate"
                                        :singleDatePicker="false"
                                        :appendToBody="true"
                                        :ranges="false"
                                        :closeOnEsc="false"
                                        :autoApply="true"
                                        :locale-data="{ format: 'dd-mm-yyyy' }"
                                        v-model="search">
                                    </date-range-picker>
                                </div>

                                <div class="col-lg-2 m-1">
                                    <button class="btn btn-info btn-sm-res" @click="queryList">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="mt-4">
                                <b-table
                                    ref="reportDelivery"
                                    show-empty
                                    responsive
                                    :items="dataList"
                                    :fields="fields"
                                    :per-page="search.perPage"
                                    :busy="busy"
                                    selectable
                                    select-mode="multi"
                                    class="scroll-bar-pop text-center"
                                    empty-text="ไม่มีข้อมูลผู้ใช้"
                                    empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                >
                                    <template slot="profit" slot-scope="data">
                                        <span>{{(data.item.agentIncome - data.item.agentCost).toFixed(2)}}</span>
                                    </template>
                                    <template slot="payStatus" slot-scope="data">
                                        <span v-if="data.item.payStatus === 1">未支付</span>
                                        <span v-if="data.item.payStatus === 2">已支付</span>
                                    </template>
                                    <template slot="action" slot-scope="data">
                                        <button class="btn btn-info btn-sm-res" @click="toCashDetail(data.item.cashNum)">
                                            รายละเอียด
                                        </button>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";
import moment from "moment";
import {queryList} from "@/api/cashRecord";

export default {
    name: "",
    data() {
        return {
            fields: [
                {key: 'cashNum', label: 'ID', sortable: true},
                {key: 'goodsCount', label: '数量', sortable: true},
                {key: 'agentIncome', label: '收入', sortable: true},
                {key: 'agentCost', label: '成本', sortable: true},
                {key: 'profit', label: '利润', sortable: true},
                {key: 'payStatus', label: '状态', sortable: true},
                {key: 'userCode', label: '收银账号', sortable: true},
                {key: 'updateTime', label: '更新时间', sortable: true},
                {key: 'action', label: '操作', sortable: false, class: 'text-center'}
            ],
            dataList: [],
            busy: false,
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            search: {
                startDate: "",
                endDate: "",
            },
            page: {
                pageIndex: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.getDateNow(new Date())
    },
    mounted() {
        this.queryList()
    },
    methods: {
        toCashDetail(row){
            this.$router.push({
                path:'/cashRecordsDetail',
                query:{
                    cashNum:row
                }
            })
        },
        queryList() {
            this.busy = true;
            let parms = {
                pageIndex: this.page.pageIndex,
                pageSize: this.page.pageSize,
                startTime: moment(this.search.startDate).format("YYYY-MM-DD") + ' 00:00:00',
                endTime: moment(this.search.endDate).format("YYYY-MM-DD") + ' 23:59:59',
            }
            console.log(parms)
            queryList(parms).then(res => {
                this.dataList = res.data.records;
                this.page.total = res.data.total
            }).finally(() => {
                this.busy = false;
            })
        },
        getDateNow(myDate) {
            // 当前日期
            var year = myDate.getFullYear();
            var month = ("0" + (myDate.getMonth() + 1)).slice(-2);
            var date = ("0" + myDate.getDate()).slice(-2);
            var formattedDate = year + "-" + month + "-" + date;

            // 前一个月的同一天
            var lastMonthDate = new Date(myDate);
            lastMonthDate.setMonth(myDate.getMonth() - 1);

            // 处理跨年问题
            if (myDate.getMonth() === 0) {
                lastMonthDate.setFullYear(myDate.getFullYear() - 1);
                lastMonthDate.setMonth(11);
            }

            var lastMonthYear = lastMonthDate.getFullYear();
            var lastMonthMonth = ("0" + (lastMonthDate.getMonth() + 1)).slice(-2);
            var lastMonthDay = ("0" + lastMonthDate.getDate()).slice(-2);
            var formattedLastMonthDate = lastMonthYear + "-" + lastMonthMonth + "-" + lastMonthDay;

            // 设置时间区间
            this.search.startDate = formattedLastMonthDate;
            this.search.endDate = formattedDate;
        },
    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>
